import { render, staticRenderFns } from "./renew.vue?vue&type=template&id=bc4e750a"
import script from "./renew.vue?vue&type=script&lang=js"
export * from "./renew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports